export default "__VITE_ASSET__BvIGrOyP__"